import { useContext, useEffect, useState, useRef, useLayoutEffect } from "react";
import { Contexto } from "@Componentes/App";
import * as _api_ from "@Funciones/api";
import * as _f_ from "@Funciones/funciones";
import * as _ipt_ from "@Elementos/Input";
import * as _btn_ from "@Elementos/Boton";
import * as _div_ from "@Elementos/Div";
import * as _anim_ from "@Elementos/Animaciones";
import ModalInformacion from "@ModalInformacion/ModalInformacion";

import "./Registro.css";

function Registro(props) {
  const { esComputadora } = useContext(Contexto);
  const { estilos, elementos } = props.param;
  
  const [componentes, _] = useState({
    input: _ipt_.Input6,
    div: _div_.Div,
    btn: _btn_.Boton
  });

  useEffect(() => { 
  },[])

  return (
    <>
    <div className="Registro" style={_f_.estilosObjetoVariablesCSS(estilos)} >
      {elementos && elementos.map((e) => {
        let [tipo, subtipo] = e.tipo.split(" ");
        tipo = tipo ?? "div";
        subtipo = subtipo ?? "";
        // console.log(tipo,subtipo)
        const Elemento = componentes[tipo];
          return (
          <Elemento texto={ e.texto } tipo = { subtipo } name={ e.name } estilos = { e.estilos } props = {e.props ?? {}}
            />)
      })}
    </div>  
    </>
  )
}
export default Registro;